"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class DrippingStore {
    constructor() {
        this.items = [];
        this.isDirty = false;
        this.pageType = null;
        this.classesForDripping = [];
        this.impactedModuleId = null;
        this.drippingCardIsOpen = new Map();
        this.deletedItems = [];
        this.setPageType = (pageType) => {
            this.pageType = pageType;
        };
        this.setImpactedModuleId = (impactedModuleId) => {
            this.impactedModuleId = impactedModuleId;
        };
    }
    clear() {
        this.items = [];
        this.deletedItems = [];
        this.isDirty = false;
        this.pageType = null;
        this.classesForDripping = [];
        this.impactedModuleId = null;
    }
    setItems(items, isDirty = true) {
        this.items = items;
        this.isDirty = isDirty;
    }
    setClassesForDripping(classesForDripping) {
        this.classesForDripping = classesForDripping;
    }
    deleteItem(drippingKey) {
        const deletedDripping = this.items.find((item) => item.key === drippingKey);
        if (deletedDripping) {
            const newDrippings = this.items.filter((item) => item.key !== drippingKey);
            this.setItems(newDrippings);
            if (deletedDripping.id) {
                this.deletedItems = [...this.deletedItems, deletedDripping.id];
            }
        }
    }
    openDrippingCard(drippingKey) {
        this.drippingCardIsOpen.set(drippingKey, true);
    }
    closeDrippingCard(drippingKey) {
        this.drippingCardIsOpen.set(drippingKey, false);
    }
    get hasExpiration() {
        return this.items.some((dripping) => dripping.expirationDays);
    }
}
__decorate([
    mobx_1.observable
], DrippingStore.prototype, "items", void 0);
__decorate([
    mobx_1.observable
], DrippingStore.prototype, "isDirty", void 0);
__decorate([
    mobx_1.observable
], DrippingStore.prototype, "pageType", void 0);
__decorate([
    mobx_1.observable
], DrippingStore.prototype, "classesForDripping", void 0);
__decorate([
    mobx_1.observable
], DrippingStore.prototype, "impactedModuleId", void 0);
__decorate([
    mobx_1.observable
], DrippingStore.prototype, "drippingCardIsOpen", void 0);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "clear", null);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "setItems", null);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "setPageType", void 0);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "setImpactedModuleId", void 0);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "setClassesForDripping", null);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "deleteItem", null);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "openDrippingCard", null);
__decorate([
    mobx_1.action
], DrippingStore.prototype, "closeDrippingCard", null);
__decorate([
    mobx_1.computed
], DrippingStore.prototype, "hasExpiration", null);
exports.default = new DrippingStore();
